const styles = {
  root: {
    display: 'flex',
    p: { xs: 1, md: 0 },
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 2,
    borderColor: 'divider',
    width: '100%',
    '&.column': {
      flexDirection: 'column!important',
    },
  },

  contentRatingIcons: {
    p: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 1,
  },

  mainbanner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  ratingNumber: {
    color: 'text.primaryDark',
    fontWeight: '600!important',
    lineHeight: '10px!important',
    fontSize: '14px!important',
    textAlign: 'center',
    mt: '5px',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: 1,
  },
  rating: {
    fontSize: 7,
  },
}

export default styles
